export const SOUL_PLAN_PERSONAL = "Soul Plan";
export const SOUL_PLAN_GROUP = "Soul Plan Group";
export const MATRIX_OF_DESTINY = "Matrix";
